import { apiRequest } from './http';
import { getStorageEstimate } from '../helpers/device';
import type { ApiEnvelope } from '../types/api';

// POST update-stats with current storage usage.
export async function updateStats(): Promise<void> {
  const storage = await getStorageEstimate();
  try {
    await apiRequest<ApiEnvelope<unknown>>('update-stats', {
      method: 'POST',
      body: { storage },
    });
  } catch {
    // Stats are best-effort; ignore failures.
  }
}
